<template>
  <div class="pa-5">
    <v-row style="margin-top: 10px">
      <v-col>
        <v-card height="400px">
          <div style="width: 100%; text-align: center;">
            <column-chart :library="chartOptions" :data="installedVersionsData" style="width: 100%; height: 200px;"></column-chart>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  components: {
  },

  computed: {
    chartOptions() {
      return {
        vAxis: {
          scaleType: 'log',
        },
      };
    },

    installedVersionsData() {
      const result = [];

      this.$store.state.specVersions.forEach((cur) => {
        if (cur.total > 1 && cur.version !== 'unknown' && cur.version !== '@@UNKOWN' && cur.version.indexOf('?') < 0) {
          result.push([cur.version, cur.total]);
        }
      });

      result.sort((a, b) => {
        const A = `${a[0].split('.')[0]}.${a[0].slice(6)}`;
        const B = `${b[0].split('.')[0]}.${b[0].slice(6)}`;

        if (A < B) {
          return -1;
        }

        if (A > B) {
          return 1;
        }

        return 0;
      });

      return result;
    },
  },
};
</script>
